import {Injectable} from '@angular/core';
import {FileService} from '@services/file.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Intervention} from '@models/intervention.model';
import {interventionProofDeliveryMethod} from '@constants/intervention.constants';

@Injectable({
  providedIn: 'root'
})
export class InterventionService {

  constructor(
    private http: HttpClient,
    private fileService: FileService
  ) { }

  async getInterventions(
    page: number,
    size: number,
    sort: string,
    startDate?: number,
    endDate?: number,
    centerId?: number,
    serviceId?: number
  ): Promise<Intervention[]> {
    const url = '/api/v1/intervention';
    let httpParams = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (sort) {
      httpParams = httpParams.set('sort', sort);
    }

    if (startDate) {
      httpParams = httpParams.set('startDate', startDate.toString());
    }

    if (endDate) {
      httpParams = httpParams.set('endDate', endDate.toString());
    }

    if (centerId) {
      httpParams = httpParams.set('centerId', centerId.toString());
    }

    if (serviceId) {
      httpParams = httpParams.set('serviceId', serviceId.toString());
    }

    return this.http.get<Intervention[]>(url, {params: httpParams}).toPromise();
  }

  async getIntervention(interventionId: number): Promise<Intervention> {
    const url = `/api/v1/intervention/${interventionId}`;
    return this.http.get<Intervention>(url).toPromise();
  }

  async getDownloadInformedConsent(interventionId: number, icId: number): Promise<void> {
    const url = `/api/v1/intervention/${interventionId}/ic/${icId}`;
    await this.fileService.downloadPdf(url);
  }

  async getProof(interventionId: number, proofDeliveryMethod?: string): Promise<void> {
    const url = `/api/v1/intervention/${interventionId}/proof`;
    const httpParams = new HttpParams().set('proofDeliveryMethod', proofDeliveryMethod);
    if (proofDeliveryMethod === interventionProofDeliveryMethod.WEB) {
      await this.fileService.downloadPdf(url, httpParams);
    } else if (proofDeliveryMethod === interventionProofDeliveryMethod.EMAIL) {
      await this.http.get(url, {params: httpParams}).toPromise();
    }
  }
}
